import React from 'react'
import Typography from './Typography'
import { cn } from '../../enviroment/lib/utils'

export function ExtBadge({ ext, className }: { ext: string; className?: string }) {
  return (
    <Typography
      variant="xs"
      className={cn(
        'shrink-0 rounded bg-gray-50 bg-opacity-50 px-1 py-0.5 uppercase tracking-wide text-gray-900',
        className,
      )}
    >
      {ext}
    </Typography>
  )
}
